// extracted by mini-css-extract-plugin
export default {"container":"StatisticsText_container__mvR7N","shortStats":"StatisticsText_shortStats__CQSVr","container2":"StatisticsText_container2__xbj4p"};